import React, {useState} from 'react';
import {useHistory} from "react-router-dom";
import {Form, Button, Row, Col, Card} from 'react-bootstrap'
import {toast} from "react-toastify";
import {authUrl, usernameOrLgPwError, copyRight, headerTextLogin, helmetTitle, helpdeskPhoneNumber} from "./data";
import ContactInfo from "./ui/ContactInfo";
import yts3glogo from './resources/ugyLogo.png';
import calllogo from "./resources/ilet.png";
import Helmet from "react-helmet";
import './App.css';

function LoginWithHeader({ setCookie }) {
    const [requestDto, setRequestDto] = useState({username: '', secPw: ''});
    let history = useHistory();
    const onAuth = (event) => {
        try {
            fetch(authUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestDto)
            }).then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(usernameOrLgPwError);
                }
            })
                .then((data) => {
                    if(data && data.jwt) {
                        var thirtyMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);
                        setCookie('subscriptionToken', data.jwt, {path: '/',expires:thirtyMinutes});
                        history.push('/subscription/tenant');
                    }
                }, (error) => {
                    if (error) {
                        toast.error(error.message, {
                            position: toast.POSITION.TOP_CENTER
                        });
                    }
                });
        } catch (e) {
            toast.error(e.message);
        }
        event.preventDefault();
    }

    const onUsernameChange = (e) => {
        if (e.target.value) {
            setRequestDto({...requestDto, username: e.target.value});
        } else {
            setRequestDto({...requestDto, username: ''});
        }
    }

    const onSecretChange = (e) => {
        if (e.target.value) {
            setRequestDto({...requestDto, secPw: e.target.value});
        } else {
            setRequestDto({...requestDto, secPw: ''});
        }
    }

    const HeaderPart = () => {
        return (
            <Row>
                <Col lg={7} style={{"whiteSpace": "nowrap"}}>
                    <img src={yts3glogo} style={{height: 75, width: 75}}
                         alt="Logo"/> {headerTextLogin}
                </Col>
                <Col lg={{span: 4, offset: 1}} className="d-none d-lg-block">
                    <Row
                        className="justify-content-end p-3 align-text-bottom align-middle align-items-center">
                        <Form.Label className="pr-3 align-middle">
                            {helpdeskPhoneNumber}
                        </Form.Label>
                        <img src={calllogo} alt="callLogo" width={50} height={50}/>
                    </Row>
                </Col>
            </Row>
        );
    };

    return (
        <div className="overflow-hidden">
            <Helmet>
                <title>{helmetTitle}</title>
            </Helmet>
            <Row style={{fontSize: 16}}>
                <Col lg={12}>
                    <Card>
                        <Card.Header as="h5" style={{height: 85}}
                                     className="align-items-center align-middle p-1 font-weight-bold">
                            <HeaderPart/>
                        </Card.Header>
                    </Card>
                </Col>
            </Row>
            <Row className="justify-content-lg-center pt-3  pb-3">
                <Col lg={3} className="login-col">
                    <Card className="shadow loginFont ovalCorner">
                        <Card.Header className="text-center">
                            UGY Abonelik Giriş
                        </Card.Header>
                        <Card.Body className="ovalCorner">
                            <Form onSubmit={onAuth}>
                                <Form.Group as={Row}>
                                    <Form.Label column>Kullanıcı Adı</Form.Label>
                                    <Col lg={8}>
                                        <Form.Control type="username"
                                                      value={requestDto.username}
                                                      onChange={onUsernameChange}/>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Form.Label column>Şifre</Form.Label>
                                    <Col lg={8}>
                                        <Form.Control type="password"
                                                      value={requestDto.secPw}
                                                      onChange={onSecretChange}/>
                                    </Col>
                                </Form.Group>
                                <Row className="justify-content-lg-center pt-3">
                                    <Button variant="primary" type="submit">
                                        Giriş
                                    </Button>
                                </Row>
                            </Form>
                        </Card.Body>
                        <Card.Footer style={{"fontSize": 11, color: "#5178B1",
                            position:"relative"}} className="text-center">
                            {copyRight}
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
            <ContactInfo/>
        </div>
    )
}

export default LoginWithHeader;